"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _line = _interopRequireDefault(require("./line"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _propTypes.default.shape({
  isDivisionOne: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  sportName: _propTypes.default.string,
  universityName: _propTypes.default.string,
  university: _propTypes.default.string,
  endYear: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  endPeriodName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  startPeriodName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  position: _propTypes.default.string,
  includeOnResume: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  id: _propTypes.default.number,
  startYear: _propTypes.default.number,
  startPeriod: _propTypes.default.number,
  endPeriod: _propTypes.default.number,
  leadership: _propTypes.default.string,
  sport: _propTypes.default.string,
  activeLines: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  lines: _propTypes.default.arrayOf(_line.default)
});
exports.default = _default;